"use client";

import { useTranslations } from "next-intl";
import { motion } from "framer-motion";
import { PillBadge } from "@/components/ui/PillBadge";
import { FAQAccordion } from "@/components/ui/FAQAccordion";
import { fadeUp, viewportOnce } from "@/lib/motion";
import { AccentColor } from "@/lib/colors";

export function FAQSection({ color }: { color: AccentColor }) {
  const t = useTranslations("FAQ");

  const items = [
    { question: t("q1"), answer: t("a1") },
    { question: t("q2"), answer: t("a2") },
    { question: t("q3"), answer: t("a3") },
    { question: t("q4"), answer: t("a4") },
    { question: t("q5"), answer: t("a5") }
  ];

  return (
    <motion.section
      className="py-12 lg:py-20 px-6"
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      variants={fadeUp}
    >
      <div className="mx-auto max-w-3xl">
        <div className="text-center mb-8 md:mb-12">
          <PillBadge label={t("pill")} variant={color} />
          <h2 className="font-display text-3xl md:text-4xl font-bold tracking-tight text-text-primary mt-4">
            {t("title")}
          </h2>
        </div>
        <FAQAccordion items={items} defaultOpen={0} />
      </div>
    </motion.section>
  );
}
